<cosmos-image [src]="element.image?.url"></cosmos-image>
